// extracted by mini-css-extract-plugin
module.exports = {"richContainer":"RichTextField_richContainer__3mX8R","customEditorClassName":"RichTextField_customEditorClassName__1OLT9","label":"RichTextField_label__31arI"};